import HighwayCore from '@dogstudio/highway/src/core';
import nextFrame from '@studiometa/js-toolkit/utils/nextFrame';
import useTransition from './useTransition.js';

let instance;

/**
 * Use highway Core
 * @param object app JS Toolkit app.
 */
export default function useHighway(app) {
  if (instance) {
    return instance;
  }

  /**
   * Highway Core
   */
  instance = new HighwayCore({
    transitions: {
      default: useTransition(app),
    },
  });

  instance.on('NAVIGATE_IN', async () => {
    // Wait for App to update
    await nextFrame();
    await nextFrame();
    app.$refs.breadcrumbContainer.innerHTML = app.$refs.breadcrumb.innerHTML;

    // Force Mobile Menu close
    app.$children.Header[0].onCloseSubmenuClick();
    app.$children.Header[0].onCloseMenuClick();
  });

  instance.on('NAVIGATE_END', async ({ to }) => {
    // Query admin bar links, and new page's admin bar links
    const adminBarLinks = document.querySelectorAll('#wpadminbar a');
    const newAdminBarLinks = to.page.body.querySelectorAll('#wpadminbar a');

    // Replace every admin bar link's href value with new value
    // eslint-disable-next-line
    for (let i = 0; i < newAdminBarLinks.length; i++) {
      adminBarLinks[i].href = newAdminBarLinks[i].href;
    }

    // Detach admin bar links from Highway transitions
    app.highway.detach(adminBarLinks);

    // Detach open submenu links
    await nextFrame();
    app.checkMenuLinks();
    window.dispatchEvent(new CustomEvent('load'));
  });

  return instance;
}
